import ProviderDetail from "./ProviderDetail";

export default ProviderDetail;
